<template>
  <div class="modal right fade" :id="objectModalName.new_system_assessment" tabindex="-1" role="dialog" aria-modal="true">
    <div class="modal-dialog" role="document">
      <button type="button" class="close md-close" @click="closeWarning('#'+objectModalName.new_system_assessment)" aria-label="Close"><span aria-hidden="true">&times;</span></button>
      <div class="modal-content">

        <div class="modal-header">
          <button type="button" class="close xs-close" data-dismiss="modal">×</button>
          <div class="row w-100">
            <div class="col-md-7 account d-flex">
              <div class="company_img">
                <img src="@/assets/img/c-logo.png" alt="User" class="img-fluid" />
              </div>
              <div>
                <p class="mb-0">{{ $t('generate') }} {{ $t('menu.system_assessment') }}
                </p>
              </div>
            </div>
          </div>

        </div>

        <div class="modal-body">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h4>Allgemein</h4>

                  <div class="form-group row">
                    <div class="col-12">
                      <label class="col-form-label">{{ $t('system') }} {{ $t('name') }}<span class="text-danger">*</span></label>
                      <input class="form-control" v-model="currentSystemAssessment.name" placeholder="Name" autocomplete="off" />
                      <span class="error-message text-danger" v-show="v$.currentSystemAssessment.name.$errors.length>0">{{ $t('required_field') }}</span>
                    </div>
                  </div> <!-- end row -->

                  <div class="form-group row">
                    <div class="col-6">
                      <label class="col-form-label">EMail<span class="text-danger">*</span></label>
                      <input class="form-control" v-model="currentSystemAssessment.email" type="email">
                      <span class="error-message text-danger" v-show="v$.currentSystemAssessment.email.$errors.length>0">{{ $t('required_field') }}</span>
                    </div>
                    <div class="col-6">
                      <label class="col-form-label">{{ $t('recipient') }}</label>
                      <input class="form-control" v-model="recipient" type="text">
                    </div>
                  </div> <!-- end row -->

                  <div class="form-group row">
                    <div class="col-4">
                      <label class="col-form-label">{{ $t('greeting') }}</label>
                      <select class="form-control" name="greeting" v-model="greeting" >
                        <option value="mr">{{ $t('mr') }}</option>
                        <option value="ms">{{ $t('ms') }}</option>
                        <option value="hello">{{ $t('hello') }}</option>
                      </select>
                    </div>
                    <div class="col-4">
                      <label class="col-form-label">{{ $t('language') }}</label>
                      <select class="form-control" name="language" v-model="language" >
                        <option value="de">{{ $t('german') }}</option>
                        <option value="en">{{ $t('english') }}</option>
                      </select>
                    </div>
                    <div class="col-4">
                      <label class="col-form-label">{{ $t('valid_date') }}<span class="text-danger">*</span></label>
                      <date-picker v-model="currentSystemAssessment.valid_date" :config="datetimeOptions"></date-picker>
                      <span class="error-message text-danger" v-show="v$.currentSystemAssessment.valid_date.$errors.length>0">{{ $t('required_field') }}</span>
                    </div>
                  </div> <!-- end row -->
                </div> <!-- end col -->
              </div> <!-- end row-->
            </div> <!-- end card-body -->
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="border-0 btn btn-warning btn-gradient-warning btn-rounded" @click.prevent="saveAndEmail">Speichern und senden den Link</button>
          <button type="button" class="btn btn-secondary btn-rounded" @click="closeWarning('#'+objectModalName.new_system_assessment)">Abbrechen</button>
        </div>

      </div><!-- modal-content -->
    </div><!-- modal-dialog -->
  </div><!-- modal -->
</template>

<script>
import {mapMutations, mapState} from 'vuex'
import service from '@/utils/request.js';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import {closeWarning, ajaxErrorMessage} from '@/utils/index.js';
import {objectModalName} from "@/utils/enums";
import datePicker from 'vue-bootstrap-datetimepicker';
import SelectGapQuestion from "@/components/component/SelectGapQuestion.vue";

  export default {
      name: "NewSystemAssessment",
      components: {datePicker},
      props: {
        currentSystemAssessment: {
          type: Object,
          required: true
        },
      },
      data() {
        return {
          objectModalName: objectModalName,
          language: 'de',
          greeting: 'mr',
          recipient:'',
          datetimeOptions: {
            format: 'YYYY-MM-DD',
            useCurrent: false,
          },
        }
      },
      validations() {
        return {
          currentSystemAssessment: {
            name: {required, $lazy: true},
            email: {required, $lazy: true},
            valid_date: {required, $lazy: true},
          },
        }
      },
      setup() {
        return {
          v$: useVuelidate()
        }
      },
      watch:{
      },
      computed: {
        ...mapState({
          user: state => state.user,
          account: state => state.account,
        }),
      },
      mounted() {
      },
      beforeDestroy() {
        $(`#${objectModalName.new_system_assessment}`).off('hidden.bs.modal')
      },
      methods: {
        closeWarning,
        ...mapMutations({setEdit: 'SET_EDIT', setModalDirty: 'SET_MODALDIRTY'}),
        async saveSystemAssessment() {
          const isValid = await this.v$.currentSystemAssessment.$validate()
          if (!isValid) {
            this.$vToastify.error('Bitte fehlende Felder vervollständigen!')
            return false
          }
          let url = `survey/v1/send_assessment_link/${this.currentSystemAssessment.id}/`
          service.request({
            url: url,
            method: 'POST',
            responseType: 'json',
            data: {
              email: this.currentSystemAssessment.email,
              valid_date: this.currentSystemAssessment.valid_date,
              modified_by: this.user.id,
              language: this.language,
              recipient: this.recipient,
              greeting: this.greeting,
            }
          }).then((response) => {
            this.v$.$reset()
            this.$emit('showSubmitResponse', response.data)
            this.$vToastify.success('System Prüfung ist erfolgreich gespeichert!')
          }).catch(error => this.$vToastify.error(ajaxErrorMessage(error)))
        },
        async saveAndEmail() {
          this.currentSystemAssessment.send_link = true
          await this.saveSystemAssessment()
          $('#' + objectModalName.new_system_assessment).modal('hide')
        },
      }
    }
</script>

<style scoped>

</style>
